var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2003,
    height: 1684,
    viewBox: "0 0 2003 1684",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1033.51 172.367H700.989C682.804 172.367 668.063 187.109 668.063 205.293C668.063 223.478 682.804 238.219 700.989 238.219H1033.51C1051.7 238.219 1066.44 223.478 1066.44 205.293C1066.44 187.109 1051.7 172.367 1033.51 172.367Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M580.497 1489.21H1156.5",
    stroke: "#120909",
    strokeWidth: 40.8189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M867.099 62.0124C554.29 62.0124 576.651 60.5813 527.046 83.7539C459.073 115.507 411.82 171.305 388.099 247.823L381.574 268.871L380.769 831.987C380.043 1339.53 380.418 1397.37 384.574 1418.04C404.907 1519.19 480.898 1596.35 582.668 1619.19C596.387 1622.26 653.675 1623.1 863.32 1623.28C1143.59 1623.52 1141.61 1623.61 1181.84 1609.64C1263.98 1581.12 1327.93 1507.53 1345.79 1420.97C1350.11 1400.03 1350.76 1315.75 1350.92 988.032H1309.32C1309.17 1319.62 1308.56 1401.68 1304.16 1418.09C1283.56 1494.95 1228.64 1551.99 1152.97 1575.12L1131.42 1581.7L874.283 1582.29C606.37 1582.9 597.098 1582.55 564.542 1570.69C533.492 1559.39 510.695 1544.54 484.763 1518.74C463.215 1497.29 456.395 1488.2 445.495 1466.39C419.751 1414.87 421.777 1468.21 421.777 842.043C421.777 215.9 419.756 269.161 445.48 217.774C456.087 196.587 463.461 186.625 483.312 166.674C509.815 140.037 531.994 125.464 563.082 114.252C600.609 100.717 609.221 100.369 878.591 101.389C1163.62 102.469 1142.47 100.836 1193.19 125.71C1216.26 137.026 1224.51 143.13 1246.5 165.196C1268.49 187.265 1274.56 195.515 1285.77 218.592C1300.15 248.203 1305.78 247.233 1308.04 343.149H1349.72C1349.29 304.562 1348.79 277.09 1348.17 273.18C1341.01 228.558 1317.3 179.419 1285.96 144.229C1256.48 111.136 1216.72 85.6966 1170.2 70.1639L1145.78 62.0124H867.099Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1945.48 337.866H1064.43C1040.6 337.866 1021.29 357.178 1021.29 381V962.241C1021.29 986.063 1040.6 1005.38 1064.43 1005.38H1945.48C1969.3 1005.38 1988.62 986.063 1988.62 962.241V381C1988.62 357.178 1969.3 337.866 1945.48 337.866Z",
    stroke: "#120909",
    strokeWidth: 27.8135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.52 467.975L1524.75 462.317",
    stroke: "#120909",
    strokeWidth: 27.8135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.52 552.828L1434.24 541.514",
    stroke: "#120909",
    strokeWidth: 27.8135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.52 648.993L1620.92 637.68",
    stroke: "#120909",
    strokeWidth: 27.8135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6152 629.405H299.892",
    stroke: "#120909",
    strokeWidth: 31.2314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6152 724.169H299.892",
    stroke: "#120909",
    strokeWidth: 31.2314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6152 818.932H299.892",
    stroke: "#120909",
    strokeWidth: 31.2314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6152 913.695H299.892",
    stroke: "#120909",
    strokeWidth: 31.2314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6152 1008.46H299.892",
    stroke: "#120909",
    strokeWidth: 31.2314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6152 1103.22H299.892",
    stroke: "#120909",
    strokeWidth: 31.2314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6152 1197.99H299.892",
    stroke: "#120909",
    strokeWidth: 31.2314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1191 756.474L1243.15 951.1L1385.1 809.151L1191 756.474Z",
    stroke: "#120909",
    strokeWidth: 27.8135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.94 878.096L1410.2 964.363",
    stroke: "#120909",
    strokeWidth: 27.8135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M860.611 490.274H578.878C555.056 490.274 535.745 509.586 535.745 533.408V1211.14C535.745 1234.96 555.056 1254.27 578.878 1254.27H860.611C884.433 1254.27 903.745 1234.96 903.745 1211.14V533.408C903.745 509.586 884.433 490.274 860.611 490.274Z",
    stroke: "#120909",
    strokeWidth: 27.8135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.15 13.9105C1110.15 13.9105 1250.45 12.1234 1319.45 81.7925C1383.8 146.769 1404.3 291.096 1404.3 291.096",
    stroke: "#120909",
    strokeWidth: 27.8135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M579.655 1670.09C579.655 1670.09 439.649 1660.82 376.351 1585.93C317.315 1516.08 308.252 1370.59 308.252 1370.59",
    stroke: "#120909",
    strokeWidth: 27.8135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiux);
export default __webpack_public_path__ + "static/media/uiux.55d6fc1bc14d53a04ed53d118cc7d35f.svg";
export { ForwardRef as ReactComponent };